export default __webpack_public_path__ + "static/media/beautiful-stories.c53d42be.jpg";